import awaitToJs from 'await-to-js'
import {
  SET_UPDATE_PROFILE,
  ALERT_COLORS,
  MESSAGE_ERROR,
  ALERT_DELAY,
} from '@App/constantes'
import Fetch from '@App/helpers/fetch'
import { setAlertBox } from './snackbar'
import { API_URL } from '@App/configs/rest'
import { getUserById, getUsersList } from '@App/store/user'

const fetchPutUserProfile = new Fetch()
const fetchActivateSecureUserAccount = new Fetch()
const fetchActivateConfirmSecureUserAccount = new Fetch()

export const setUpdateProfile = (user: any) => {
  return {
    type: SET_UPDATE_PROFILE,
    payload: user,
  }
}

export const activateSecureUserAccount = (body: any) => {
  return async (dispatch: any) => {
    const [err, data] = await awaitToJs(fetchActivateSecureUserAccount.post({
      body,
      url: `${API_URL}/users/auth/two-factor/activate`,
      headers: {
        'content-type': 'application/json',
      },
    }))

    if (!err && data) {
      return data
    }

    if (err) {
      dispatch(setAlertBox({
        title: err && err.message || MESSAGE_ERROR,
        background: ALERT_COLORS.red,
        delay: ALERT_DELAY,
      }))

      return err
    }
  }
}

export const activateConfirmSecureUserAccount = (body: any) => {
  return async (dispatch: any, getState: any) => {
    const [err, data] = await awaitToJs(fetchActivateConfirmSecureUserAccount.post({
      body,
      url: `${API_URL}/users/auth/two-factor/activate-confirm`,
      headers: {
        'content-type': 'application/json',
      },
    }))

    if (!err && data) {
      dispatch(setAlertBox({
        title: data && data.message,
        background: ALERT_COLORS.green,
        delay: ALERT_DELAY,
      }))

      dispatch(getUserById(getState().user.user.id))

      return data
    }

    if (err) {
      dispatch(setAlertBox({
        title: err && err.message || MESSAGE_ERROR,
        background: ALERT_COLORS.red,
        delay: ALERT_DELAY,
      }))

      return err
    }
  }
}

export const getUpdateProfile = (body: any) => {
  return async (dispatch: any) => {
    const [err, data] = await awaitToJs(fetchPutUserProfile.put({
      body,
      url: `${API_URL}/users/`,
      headers: {
        'content-type': 'application/json',
      },
    }))

    if (!err && data) {
      dispatch(setAlertBox({
        title: 'Utilisateur mis à jour',
        background: ALERT_COLORS.green,
        delay: ALERT_DELAY,
      }))

      dispatch(setUpdateProfile(data))
      return data
    }

    if (err) {
      dispatch(setAlertBox({
        title: err && err.message || MESSAGE_ERROR,
        background: ALERT_COLORS.red,
        delay: ALERT_DELAY,
      }))

      return err
    }
  }
}
